
import { QueryClient } from '@tanstack/react-query';
import { getAgentCollaborationScore } from './agentCollaboration';

// Create a global query client instance
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
      refetchOnWindowFocus: false,
    },
  },
});

// Initialize monitoring features
export const initMonitoring = () => {
  // Placeholder for future monitoring setup
  console.log('Monitoring initialized');
};

// Export the agent collaboration score function
export { getAgentCollaborationScore };
